"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3197],{

/***/ 23774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardBody = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-df4f0a61-0"
}).withConfig({
    componentId: "sc-657c9e-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
CardBody.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardBody);


/***/ }),

/***/ 95596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardFooter = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5ed8a823-0"
}).withConfig({
    componentId: "sc-cddac6ee-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
CardFooter.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardFooter);


/***/ }),

/***/ 18842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44747);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: ",
        ";\n  background-color: ",
        ";\n  color: white;\n  margin: 0;\n  padding: 0;\n  padding: 8px 0;\n  position: absolute;\n  right: ",
        ";\n  top: 0;\n  text-align: center;\n  transform: translateX(30%) translateY(0%) rotate(45deg);\n  transform: ",
        ";\n  transform-origin: top left;\n  width: 96px;\n\n  &:before,\n  &:after {\n    background-color: ",
        ';\n    content: "";\n    height: 100%;\n    margin: 0 -1px; /* Removes tiny gap */\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n\n  &:before {\n    right: 100%;\n  }\n\n  &:after {\n    left: 100%;\n  }\n\n  & > div {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 96px;\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledCardRibbon = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-71d54b13-0"
}).withConfig({
    componentId: "sc-a0765e33-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.zIndices.ribbon;
}, function(param) {
    var _variantColor = param.variantColor, variantColor = _variantColor === void 0 ? "secondary" : _variantColor, theme = param.theme;
    return theme.colors[variantColor];
}, function(param) {
    var ribbonPosition = param.ribbonPosition;
    return ribbonPosition === "right" ? 0 : "auto";
}, function(param) {
    var ribbonPosition = param.ribbonPosition;
    return ribbonPosition === "right" ? "translateX(30%) translateY(0%) rotate(45deg)" : "translateX(0%) translateY(200%) rotate(-45deg)";
}, function(param) {
    var _variantColor = param.variantColor, variantColor = _variantColor === void 0 ? "secondary" : _variantColor, theme = param.theme;
    return theme.colors[variantColor];
});
var CardRibbon = function CardRibbon(_param) {
    var variantColor = _param.variantColor, text = _param.text, ribbonPosition = _param.ribbonPosition, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "variantColor",
        "text",
        "ribbonPosition"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCardRibbon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        variantColor: variantColor,
        ribbonPosition: ribbonPosition
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            title: text,
            children: text
        })
    }));
};
CardRibbon.defaultProps = {
    //eslint-disable-next-line react/default-props-match-prop-types
    ribbonPosition: "right"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardRibbon);


/***/ }),

/***/ 3895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CakeVaultCard; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(44747);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(23774);
// EXTERNAL MODULE: ./packages/uikit/src/components/Image/TokenPairImage.tsx + 2 modules
var TokenPairImage = __webpack_require__(56503);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(30621);
// EXTERNAL MODULE: ./src/components/Layout/Flex.tsx
var Layout_Flex = __webpack_require__(40508);
// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(9070);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/state/pools/hooks.ts + 1 modules
var hooks = __webpack_require__(23637);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/views/Pools/components/PoolCard/CardFooter/index.tsx
var CardFooter = __webpack_require__(73322);
// EXTERNAL MODULE: ./src/views/Pools/components/PoolCard/PoolCardHeader.tsx
var PoolCardHeader = __webpack_require__(68624);
// EXTERNAL MODULE: ./src/views/Pools/components/PoolCard/StyledCard.tsx
var StyledCard = __webpack_require__(12020);
// EXTERNAL MODULE: ./src/views/Pools/components/Vault/VaultPositionTag.tsx + 4 modules
var VaultPositionTag = __webpack_require__(76189);
// EXTERNAL MODULE: ./src/views/Pools/components/CakeVaultCard/UnstakingFeeCountdownRow.tsx + 1 modules
var UnstakingFeeCountdownRow = __webpack_require__(33649);
// EXTERNAL MODULE: ./src/views/Pools/helpers.tsx
var helpers = __webpack_require__(53136);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(36544);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(17634);
// EXTERNAL MODULE: ./src/components/Balance.tsx
var Balance = __webpack_require__(20922);
// EXTERNAL MODULE: ./src/views/Pools/components/AutoEarningsBreakdown.tsx
var AutoEarningsBreakdown = __webpack_require__(37528);
;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/RecentCakeProfitBalance.tsx




var RecentCakeProfitBalance = function(param) {
    var cakeToDisplay = param.cakeToDisplay, pool = param.pool, account = param.account;
    var ref = (0,useTooltip/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(AutoEarningsBreakdown/* default */.Z, {
        pool: pool,
        account: account
    }), {
        placement: "bottom-end"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                ref: targetRef,
                small: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.ZP, {
                    fontSize: "14px",
                    value: cakeToDisplay
                })
            })
        ]
    });
};
/* harmony default export */ var CakeVaultCard_RecentCakeProfitBalance = (RecentCakeProfitBalance);

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/RecentCakeProfitRow.tsx








var RecentCakeProfitCountdownRow = function(param) {
    var pool = param.pool;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref = (0,hooks/* useVaultPoolByKey */.eB)(pool.vaultKey), pricePerFullShare = ref.pricePerFullShare, _userData = ref.userData, cakeAtLastUserAction = _userData.cakeAtLastUserAction, userShares = _userData.userShares, currentOverdueFee = _userData.currentOverdueFee, currentPerformanceFee = _userData.currentPerformanceFee;
    var cakePriceBusd = (0,bignumber/* default */.Z)(localStorage.getItem("price"));
    var ref1 = (0,helpers/* getCakeVaultEarnings */.UN)(account, cakeAtLastUserAction, userShares, pricePerFullShare, cakePriceBusd.toNumber(), currentPerformanceFee.plus(currentOverdueFee)), hasAutoEarnings = ref1.hasAutoEarnings, autoCakeToDisplay = ref1.autoCakeToDisplay;
    if (!(userShares.gt(0) && account)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "14px",
                children: "".concat(t("Recent CAKE profit"), ":")
            }),
            hasAutoEarnings && /*#__PURE__*/ (0,jsx_runtime.jsx)(CakeVaultCard_RecentCakeProfitBalance, {
                cakeToDisplay: autoCakeToDisplay,
                pool: pool,
                account: account
            })
        ]
    });
};
/* harmony default export */ var RecentCakeProfitRow = (RecentCakeProfitCountdownRow);

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(9941);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Calculate.tsx
var Calculate = __webpack_require__(47509);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
// EXTERNAL MODULE: ./src/hooks/useVaultApy.ts
var useVaultApy = __webpack_require__(41273);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/views/Pools/components/Vault/VaultRoiCalculatorModal.tsx + 1 modules
var VaultRoiCalculatorModal = __webpack_require__(58745);
;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/StakingApy.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var AprLabelContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-563431b4-0"
})(_templateObject());
var StakingApy = /*#__PURE__*/ (0,react.memo)(function(param) {
    var pool = param.pool;
    var flexibleApy = (0,useVaultApy/* useVaultApy */.o)().flexibleApy;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(VaultRoiCalculatorModal/* VaultRoiCalculatorModal */.E, {
        pool: pool
    })), 1), onPresentFlexibleApyModal = ref[0];
    // const [onPresentLockedApyModal] = useModal(<VaultRoiCalculatorModal pool={pool} initialView={1} />)
    return(// <LightGreyCard>
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                textTransform: "uppercase",
                bold: true,
                fontSize: "16px",
                children: t("APY:")
            }),
            flexibleApy ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(AprLabelContainer, {
                alignItems: "center",
                justifyContent: "flex-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.ZP, {
                        fontSize: "16px",
                        value: parseFloat(flexibleApy),
                        decimals: 2,
                        unit: "%",
                        bold: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: function(e) {
                            e.stopPropagation();
                            onPresentFlexibleApyModal();
                        },
                        variant: "text",
                        width: "20px",
                        height: "20px",
                        padding: "0px",
                        marginLeft: "4px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Calculate/* default */.Z, {
                            color: "textSubtle",
                            width: "20px"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                width: "80px",
                height: "16px"
            })
        ]
    }));
});

// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(35128);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(19729);
// EXTERNAL MODULE: ./src/views/Pools/hooks/useApprove.tsx + 1 modules
var useApprove = __webpack_require__(51029);
;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/VaultCardActions/VaultApprovalAction.tsx




var VaultApprovalAction = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, setLastUpdated = param.setLastUpdated;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var ref = (0,useApprove/* useVaultApprove */.Le)(setLastUpdated), handleApprove = ref.handleApprove, pendingTx = ref.pendingTx;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            width: "100%",
            height: "52px"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            isLoading: pendingTx,
            endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                spin: true,
                color: "currentColor"
            }) : null,
            disabled: pendingTx,
            onClick: handleApprove,
            width: "100%",
            children: t("Enable")
        })
    });
};
/* harmony default export */ var VaultCardActions_VaultApprovalAction = (VaultApprovalAction);

// EXTERNAL MODULE: ./src/views/Pools/components/PoolCard/Modals/NotEnoughTokensModal.tsx
var NotEnoughTokensModal = __webpack_require__(67576);
// EXTERNAL MODULE: ./src/views/Pools/components/Vault/VaultStakeButtonGroup.tsx
var VaultStakeButtonGroup = __webpack_require__(58427);
// EXTERNAL MODULE: ./src/views/Pools/components/CakeVaultCard/VaultStakeModal.tsx + 1 modules
var VaultStakeModal = __webpack_require__(86487);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Modals/LockedStakeModal.tsx
var LockedStakeModal = __webpack_require__(24237);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Minus.tsx
var Minus = __webpack_require__(72943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Add.tsx
var Add = __webpack_require__(543);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var farms_hooks = __webpack_require__(17166);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Common/ConvertToLock.tsx
var ConvertToLock = __webpack_require__(24416);
;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/VaultCardActions/HasSharesActions.tsx






// import { usePriceCakeBusd } from 'state/farms/hooks'






var HasSharesActions = function(param) {
    var pool = param.pool, stakingTokenBalance = param.stakingTokenBalance, performanceFee = param.performanceFee;
    var ref = (0,hooks/* useVaultPoolByKey */.eB)(pool.vaultKey), _userData = ref.userData, _balance = _userData.balance, cakeAsBigNumber = _balance.cakeAsBigNumber, cakeAsNumberBalance = _balance.cakeAsNumberBalance;
    var stakingToken = pool.stakingToken;
    var ref1 = (0,react.useState)(new bignumber/* default */.Z(0)), cakePriceBusd = ref1[0], setCakePriceUsd = ref1[1];
    (0,react.useEffect)(function() {
        // const pairAddress = getAddress(testnetTokens.rp1, testnetTokens.usdt)
        // const contract = getLpContract(pairAddress)
        // contract.getReserves().then((data) => {
        // const reserve1 = data._reserve1.toString()
        // const reserve0 = data._reserve0.toString()
        // const price = new BigNumber(reserve1).div(new BigNumber(reserve0))
        var price = (0,farms_hooks/* rp1PriceUsd */.gt)();
        setCakePriceUsd(new bignumber/* default */.Z(price));
    // return price
    // })
    }, []);
    // const cakePriceBusd = usePriceCakeBusd()
    var stakedDollarValue = cakePriceBusd.gt(0) ? (0,formatBalance/* getBalanceNumber */.mW)(cakeAsBigNumber.multipliedBy(cakePriceBusd), stakingToken.decimals) : 0;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(NotEnoughTokensModal/* default */.Z, {
        tokenSymbol: stakingToken.symbol
    })), 1), onPresentTokenRequired = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(VaultStakeModal/* default */.Z, {
        stakingMax: stakingTokenBalance,
        performanceFee: performanceFee,
        pool: pool
    })), 1), onPresentStake = ref3[0];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(VaultStakeModal/* default */.Z, {
        stakingMax: cakeAsBigNumber,
        pool: pool,
        isRemovingStake: true
    }), true, true, "withdraw-vault"), 1), onPresentUnstake = ref4[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                mb: "16px",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.ZP, {
                                fontSize: "20px",
                                bold: true,
                                value: cakeAsNumberBalance,
                                decimals: 5
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                as: Flex/* default */.Z,
                                fontSize: "12px",
                                color: "textSubtle",
                                flexWrap: "wrap",
                                children: cakePriceBusd.gt(0) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.ZP, {
                                    value: stakedDollarValue,
                                    fontSize: "12px",
                                    color: "textSubtle",
                                    decimals: 2,
                                    prefix: "~",
                                    unit: " USD"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    mt: "1px",
                                    height: 16,
                                    width: 64
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                variant: "secondary",
                                onClick: onPresentUnstake,
                                mr: "6px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {
                                    color: "primary",
                                    width: "24px"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                variant: "secondary",
                                onClick: stakingTokenBalance.gt(0) ? onPresentStake : onPresentTokenRequired,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                    color: "primary",
                                    width: "24px",
                                    height: "24px"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: "16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConvertToLock/* default */.Z, {
                    stakingToken: stakingToken,
                    currentStakedAmount: cakeAsNumberBalance
                })
            })
        ]
    });
};
/* harmony default export */ var VaultCardActions_HasSharesActions = (HasSharesActions);

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/VaultCardActions/VaultStakeActions.tsx









var VaultStakeActions = function(param) {
    var pool = param.pool, stakingTokenBalance = param.stakingTokenBalance, accountHasSharesStaked = param.accountHasSharesStaked, performanceFee = param.performanceFee;
    var stakingToken = pool.stakingToken;
    var userDataLoaded = (0,hooks/* usePoolsWithVault */.f6)().userDataLoaded;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(NotEnoughTokensModal/* default */.Z, {
        tokenSymbol: stakingToken.symbol
    })), 1), onPresentTokenRequired = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(VaultStakeModal/* default */.Z, {
        stakingMax: stakingTokenBalance,
        pool: pool,
        performanceFee: performanceFee
    })), 1), onPresentStake = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(LockedStakeModal/* default */.Z, {
        currentBalance: stakingTokenBalance,
        stakingToken: stakingToken,
        stakingTokenBalance: stakingTokenBalance
    })), 1), openPresentLockedStakeModal = ref2[0];
    var renderStakeAction = function() {
        return accountHasSharesStaked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultCardActions_HasSharesActions, {
            pool: pool,
            stakingTokenBalance: stakingTokenBalance,
            performanceFee: performanceFee
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultStakeButtonGroup/* VaultStakeButtonGroup */.w, {
            onFlexibleClick: stakingTokenBalance.gt(0) ? onPresentStake : onPresentTokenRequired,
            onLockedClick: openPresentLockedStakeModal
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        children: userDataLoaded ? renderStakeAction() : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            width: "100%",
            height: "52px"
        })
    });
};
/* harmony default export */ var VaultCardActions_VaultStakeActions = (VaultStakeActions);

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/VaultCardActions/index.tsx

function VaultCardActions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n"
    ]);
    VaultCardActions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var InlineText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-de8cbb6e-0"
})(VaultCardActions_templateObject());
var CakeVaultCardActions = function(param) {
    var pool = param.pool, accountHasSharesStaked = param.accountHasSharesStaked, isLoading = param.isLoading, performanceFee = param.performanceFee;
    var stakingToken = pool.stakingToken, userData = pool.userData;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var stakingTokenBalance = (userData === null || userData === void 0 ? void 0 : userData.stakingTokenBalance) ? new bignumber/* default */.Z(userData.stakingTokenBalance) : bigNumber/* BIG_ZERO */.HW;
    var ref = (0,useApprove/* useCheckVaultApprovalStatus */.dI)(), isVaultApproved = ref.isVaultApproved, setLastUpdated = ref.setLastUpdated;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "inline",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InlineText, {
                            color: accountHasSharesStaked ? "secondary" : "textSubtle",
                            textTransform: "uppercase",
                            bold: true,
                            fontSize: "12px",
                            children: [
                                accountHasSharesStaked ? stakingToken.symbol : t("Stake"),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineText, {
                            color: accountHasSharesStaked ? "textSubtle" : "secondary",
                            textTransform: "uppercase",
                            bold: true,
                            fontSize: "12px",
                            children: accountHasSharesStaked ? t("Staked") : "".concat(stakingToken.symbol)
                        })
                    ]
                }),
                isVaultApproved ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultCardActions_VaultStakeActions, {
                    pool: pool,
                    stakingTokenBalance: stakingTokenBalance,
                    accountHasSharesStaked: accountHasSharesStaked,
                    performanceFee: performanceFee
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultCardActions_VaultApprovalAction, {
                    isLoading: isLoading,
                    setLastUpdated: setLastUpdated
                })
            ]
        })
    });
};
/* harmony default export */ var VaultCardActions = (CakeVaultCardActions);

// EXTERNAL MODULE: ./src/utils/cakePool.ts
var cakePool = __webpack_require__(17101);
// EXTERNAL MODULE: ./src/components/Card/index.tsx
var Card = __webpack_require__(36261);
// EXTERNAL MODULE: ./src/components/Divider/index.tsx
var Divider = __webpack_require__(14275);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(90834);
// EXTERNAL MODULE: ./src/utils/isUndefinedOrNull.ts
var isUndefinedOrNull = __webpack_require__(12157);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Common/BurningCountDown.tsx
var BurningCountDown = __webpack_require__(88028);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Buttons/AddCakeButton.tsx + 1 modules
var AddCakeButton = __webpack_require__(90706);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Buttons/ExtendDurationButton.tsx + 2 modules
var ExtendDurationButton = __webpack_require__(28353);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Common/AfterLockedActions.tsx + 1 modules
var AfterLockedActions = __webpack_require__(39421);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/Common/LockedActions.tsx











var LockedActions = function(param) {
    var userShares = param.userShares, locked = param.locked, lockEndTime = param.lockEndTime, lockStartTime = param.lockStartTime, stakingToken = param.stakingToken, stakingTokenBalance = param.stakingTokenBalance, lockedAmount = param.lockedAmount;
    var position = (0,react.useMemo)(function() {
        return (0,cakePool/* getVaultPosition */.cP)({
            userShares: userShares,
            locked: locked,
            lockEndTime: lockEndTime
        });
    }, [
        userShares,
        locked,
        lockEndTime
    ]);
    var t = (0,Localization/* useTranslation */.$G)().t;
    var lockedAmountAsNumber = (0,formatBalance/* getBalanceNumber */.mW)(lockedAmount);
    var currentBalance = (0,react.useMemo)(function() {
        return stakingTokenBalance ? new bignumber/* default */.Z(stakingTokenBalance) : bigNumber/* BIG_ZERO */.HW;
    }, [
        stakingTokenBalance
    ]);
    if (position === cakePool/* VaultPosition.Locked */.PS.Locked) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    width: "100%",
                    mr: "4px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCakeButton/* default */.Z, {
                        lockEndTime: lockEndTime,
                        lockStartTime: lockStartTime,
                        currentLockedAmount: lockedAmount,
                        stakingToken: stakingToken,
                        currentBalance: currentBalance,
                        stakingTokenBalance: stakingTokenBalance
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    width: "100%",
                    ml: "4px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtendDurationButton/* default */.Z, {
                        lockEndTime: lockEndTime,
                        lockStartTime: lockStartTime,
                        stakingToken: stakingToken,
                        currentLockedAmount: lockedAmountAsNumber,
                        children: t("Extend")
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AfterLockedActions/* default */.Z, {
        lockEndTime: lockEndTime,
        lockStartTime: lockStartTime,
        position: position,
        currentLockedAmount: lockedAmountAsNumber,
        stakingToken: stakingToken
    });
};
/* harmony default export */ var Common_LockedActions = (LockedActions);

// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Common/YieldBoostRow.tsx
var YieldBoostRow = __webpack_require__(96635);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/Common/LockDurationRow.tsx
var LockDurationRow = __webpack_require__(5450);
// EXTERNAL MODULE: ./src/views/Pools/components/LockedPool/hooks/useUserDataInVaultPresenter.ts
var useUserDataInVaultPresenter = __webpack_require__(51553);
;// CONCATENATED MODULE: ./src/views/Pools/components/LockedPool/LockedStakingApy.tsx

















var LockedStakingApy = function(param) {
    var stakingToken = param.stakingToken, stakingTokenBalance = param.stakingTokenBalance, userData = param.userData;
    var ref;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var position = (0,react.useMemo)(function() {
        return (0,cakePool/* getVaultPosition */.cP)({
            userShares: userData === null || userData === void 0 ? void 0 : userData.userShares,
            locked: userData === null || userData === void 0 ? void 0 : userData.locked,
            lockEndTime: userData === null || userData === void 0 ? void 0 : userData.lockEndTime
        });
    }, [
        userData
    ]);
    var currentLockedAmountAsBigNumber = (0,react.useMemo)(function() {
        var ref;
        return userData === null || userData === void 0 ? void 0 : (ref = userData.balance) === null || ref === void 0 ? void 0 : ref.cakeAsBigNumber;
    }, [
        userData === null || userData === void 0 ? void 0 : (ref = userData.balance) === null || ref === void 0 ? void 0 : ref.cakeAsBigNumber
    ]);
    var currentLockedAmount = (0,formatBalance/* getBalanceNumber */.mW)(currentLockedAmountAsBigNumber);
    var usdValueStaked = (0,useBUSDPrice/* useBUSDCakeAmount */.Tx)(currentLockedAmount);
    var ref1 = (0,useUserDataInVaultPresenter/* default */.Z)({
        lockStartTime: userData === null || userData === void 0 ? void 0 : userData.lockStartTime,
        lockEndTime: userData === null || userData === void 0 ? void 0 : userData.lockEndTime
    }), weekDuration = ref1.weekDuration, lockEndDate = ref1.lockEndDate, secondDuration = ref1.secondDuration, remainingTime = ref1.remainingTime;
    var lockedApy = (0,useVaultApy/* useVaultApy */.o)({
        duration: secondDuration
    }).lockedApy;
    // earningTokenBalance includes overdue fee if any
    var earningTokenBalance = (0,react.useMemo)(function() {
        return (0,formatBalance/* getBalanceNumber */.mW)(currentLockedAmountAsBigNumber.minus(userData === null || userData === void 0 ? void 0 : userData.cakeAtLastUserAction));
    }, [
        currentLockedAmountAsBigNumber,
        userData === null || userData === void 0 ? void 0 : userData.cakeAtLastUserAction
    ]);
    var tooltipContent = t("Calculated based on current rates and subject to change based on pool conditions. It is an estimate provided for your convenience only, and by no means represents guaranteed returns.");
    var ref2 = (0,useTooltip/* default */.Z)(tooltipContent, {
        placement: "bottom-start"
    }), targetRef = ref2.targetRef, tooltip = ref2.tooltip, tooltipVisible = ref2.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* LightGreyCard */.m5, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                mb: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                textTransform: "uppercase",
                                bold: true,
                                fontSize: "12px",
                                children: t("CAKE locked")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.sC, {
                                color: "text",
                                bold: true,
                                fontSize: "16px",
                                value: currentLockedAmount,
                                decimals: 5
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.sC, {
                                value: usdValueStaked,
                                fontSize: "12px",
                                color: "textSubtle",
                                decimals: 2,
                                prefix: "~",
                                unit: " USD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "textSubtle",
                                textTransform: "uppercase",
                                bold: true,
                                fontSize: "12px",
                                children: t("Unlocks In")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: position >= cakePool/* VaultPosition.LockedEnd */.PS.LockedEnd ? "#D67E0A" : "text",
                                bold: true,
                                fontSize: "16px",
                                children: position >= cakePool/* VaultPosition.LockedEnd */.PS.LockedEnd ? t("Unlocked") : remainingTime
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: position >= cakePool/* VaultPosition.LockedEnd */.PS.LockedEnd ? "#D67E0A" : "text",
                                fontSize: "12px",
                                children: t("On %date%", {
                                    date: lockEndDate
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: "16px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_LockedActions, {
                    userShares: userData === null || userData === void 0 ? void 0 : userData.userShares,
                    locked: userData === null || userData === void 0 ? void 0 : userData.locked,
                    lockEndTime: userData === null || userData === void 0 ? void 0 : userData.lockEndTime,
                    lockStartTime: userData === null || userData === void 0 ? void 0 : userData.lockStartTime,
                    stakingToken: stakingToken,
                    stakingTokenBalance: stakingTokenBalance,
                    lockedAmount: currentLockedAmountAsBigNumber
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
            ![
                cakePool/* VaultPosition.LockedEnd */.PS.LockedEnd,
                cakePool/* VaultPosition.AfterBurning */.PS.AfterBurning
            ].includes(position) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    tooltipVisible && tooltip,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            ref: targetRef,
                            color: "textSubtle",
                            textTransform: "uppercase",
                            bold: true,
                            fontSize: "12px",
                            children: t("APY")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.sC, {
                        color: "text",
                        bold: true,
                        fontSize: "16px",
                        value: parseFloat(lockedApy),
                        decimals: 2,
                        unit: "%"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LockDurationRow/* default */.Z, {
                weekDuration: weekDuration
            }),
            ![
                cakePool/* VaultPosition.LockedEnd */.PS.LockedEnd,
                cakePool/* VaultPosition.AfterBurning */.PS.AfterBurning
            ].includes(position) && /*#__PURE__*/ (0,jsx_runtime.jsx)(YieldBoostRow/* default */.Z, {
                secondDuration: secondDuration
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        textTransform: "uppercase",
                        bold: true,
                        fontSize: "12px",
                        children: t("Recent CAKE profit")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* BalanceWithLoading */.sC, {
                        color: "text",
                        bold: true,
                        fontSize: "16px",
                        value: earningTokenBalance,
                        decimals: 5
                    })
                ]
            }),
            position === cakePool/* VaultPosition.LockedEnd */.PS.LockedEnd && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        textTransform: "uppercase",
                        bold: true,
                        fontSize: "12px",
                        children: t("After Burning In")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "failure",
                        bold: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BurningCountDown/* default */.Z, {
                            lockEndTime: userData === null || userData === void 0 ? void 0 : userData.lockEndTime
                        })
                    })
                ]
            }),
            position === cakePool/* VaultPosition.AfterBurning */.PS.AfterBurning && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        textTransform: "uppercase",
                        bold: true,
                        fontSize: "12px",
                        children: t("After burning")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "failure",
                        bold: true,
                        children: (0,isUndefinedOrNull/* default */.Z)(userData === null || userData === void 0 ? void 0 : userData.currentOverdueFee) ? "-" : t("%amount% Burned", {
                            amount: (0,formatBalance/* getFullDisplayBalance */.NJ)(userData === null || userData === void 0 ? void 0 : userData.currentOverdueFee, 18, 5)
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LockedPool_LockedStakingApy = (/*#__PURE__*/(0,react.memo)(LockedStakingApy));

;// CONCATENATED MODULE: ./src/views/Pools/components/CakeVaultCard/index.tsx




function CakeVaultCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: ",
        ";\n"
    ]);
    CakeVaultCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


















var StyledCardBody = (0,styled_components_browser_esm/* default */.ZP)(CardBody/* default */.Z).withConfig({
    componentId: "sc-6be4dd29-0"
})(CakeVaultCard_templateObject(), function(param) {
    var isLoading = param.isLoading;
    return isLoading ? "0" : "254px";
});
var CakeVaultCard = function(_param) {
    var pool = _param.pool, showStakedOnly = _param.showStakedOnly, defaultFooterExpanded = _param.defaultFooterExpanded, props = (0,_object_without_properties/* default */.Z)(_param, [
        "pool",
        "showStakedOnly",
        "defaultFooterExpanded"
    ]);
    var ref, ref1;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var vaultPool = (0,hooks/* useVaultPoolByKey */.eB)(pool.vaultKey);
    var _userData = vaultPool.userData, userShares = _userData.userShares, isVaultUserDataLoading = _userData.isLoading, performanceFeeAsDecimal = vaultPool.fees.performanceFeeAsDecimal;
    var accountHasSharesStaked = userShares && userShares.gt(0);
    var isLoading = !pool.userData || isVaultUserDataLoading;
    if (showStakedOnly && !accountHasSharesStaked) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard/* StyledCard */.r, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PoolCardHeader/* default */.Z, {
                isStaking: accountHasSharesStaked,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolCardHeader/* PoolCardHeaderTitle */.e, {
                        title: pools/* vaultPoolConfig */.Y4[pool.vaultKey].name,
                        subTitle: pools/* vaultPoolConfig */.Y4[pool.vaultKey].description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenPairImage/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pools/* vaultPoolConfig */.Y4[pool.vaultKey].tokenImage), {
                        width: 40,
                        height: 40
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardBody, {
                isLoading: isLoading,
                children: [
                    account && /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultPositionTag/* VaultPositionTagWithLabel */.X, {
                        userData: vaultPool.userData
                    }),
                    account && (vaultPool === null || vaultPool === void 0 ? void 0 : (ref = vaultPool.userData) === null || ref === void 0 ? void 0 : ref.locked) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LockedPool_LockedStakingApy, {
                        userData: vaultPool === null || vaultPool === void 0 ? void 0 : vaultPool.userData,
                        stakingToken: pool === null || pool === void 0 ? void 0 : pool.stakingToken,
                        stakingTokenBalance: pool === null || pool === void 0 ? void 0 : (ref1 = pool.userData) === null || ref1 === void 0 ? void 0 : ref1.stakingTokenBalance
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StakingApy, {
                                pool: pool
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_Flex/* FlexGap */.O, {
                                mt: "16px",
                                gap: "8px",
                                flexDirection: accountHasSharesStaked ? "column-reverse" : "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        children: [
                                            account && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                mb: "8px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstakingFeeCountdownRow/* default */.Z, {
                                                    vaultKey: pool.vaultKey
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentCakeProfitRow, {
                                                pool: pool
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        flexDirection: "column",
                                        children: account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VaultCardActions, {
                                            pool: pool,
                                            accountHasSharesStaked: accountHasSharesStaked,
                                            isLoading: isLoading,
                                            performanceFee: performanceFeeAsDecimal
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    mb: "10px",
                                                    textTransform: "uppercase",
                                                    fontSize: "12px",
                                                    color: "textSubtle",
                                                    bold: true,
                                                    children: t("Start earning")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {})
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardFooter/* default */.Z, {
                pool: pool,
                account: account
            })
        ]
    }));
};
/* harmony default export */ var components_CakeVaultCard = (CakeVaultCard);


/***/ }),

/***/ 73322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var contexts_Localization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99150);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36544);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95596);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10763);
/* harmony import */ var components_Tags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54793);
/* harmony import */ var _PoolStatsInfo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91692);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  justify-content: space-between;\n  button {\n    padding: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  svg {\n    height: 14px;\n    width: 14px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var ExpandableButtonWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f5e8293a-0"
})(_templateObject());
var ExpandedWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f5e8293a-1"
})(_templateObject1());
var Footer = function(param) {
    var pool = param.pool, account = param.account, defaultExpanded = param.defaultExpanded, children = param.children;
    var vaultKey = pool.vaultKey;
    var t = (0,contexts_Localization__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(defaultExpanded || false), isExpanded = ref[0], setIsExpanded = ref[1];
    var manualTooltipText = t("You must harvest and compound your earnings from this pool manually.");
    var autoTooltipText = t("Rewards are distributed and included into your staking balance automatically. There’s no need to manually compound your rewards.");
    var ref1 = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(vaultKey ? autoTooltipText : manualTooltipText, {
        placement: "bottom"
    }), targetRef = ref1.targetRef, tooltip = ref1.tooltip, tooltipVisible = ref1.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ExpandableButtonWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        alignItems: "center",
                        children: [
                            vaultKey ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Tags__WEBPACK_IMPORTED_MODULE_4__/* .CompoundingPoolTag */ .yd, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Tags__WEBPACK_IMPORTED_MODULE_4__/* .ManualPoolTag */ .EM, {}),
                            tooltipVisible && tooltip
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* .ExpandableLabel */ .L, {
                        expanded: isExpanded,
                        onClick: function() {
                            return setIsExpanded(!isExpanded);
                        },
                        children: isExpanded ? t("Hide") : t("Details")
                    })
                ]
            }),
            isExpanded && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ExpandedWrapper, {
                flexDirection: "column",
                children: children || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PoolStatsInfo__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    pool: pool,
                    account: account
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 68624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ PoolCardHeaderTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87654);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59750);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97114);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b183b045-0"
})(_templateObject(), function(param) {
    var isFinished = param.isFinished, background = param.background, theme = param.theme;
    return isFinished ? theme.colors.backgroundDisabled : theme.colors.backgroundAlt;
}, function(param) {
    var theme = param.theme;
    return "".concat(theme.radii.card, " ").concat(theme.radii.card, " 0 0");
});
var PoolCardHeader = function(param) {
    var _isFinished = param.isFinished, isFinished = _isFinished === void 0 ? false : _isFinished, _isStaking = param.isStaking, isStaking = _isStaking === void 0 ? false : _isStaking, children = param.children;
    var background = isStaking ? "bubblegum" : "cardHeader";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        isFinished: isFinished,
        background: background,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            alignItems: "center",
            justifyContent: "space-between",
            children: children
        })
    });
};
var PoolCardHeaderTitle = function(param) {
    var isFinished = param.isFinished, title = param.title, subTitle = param.subTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                color: isFinished ? "textDisabled" : "body",
                scale: "lg",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                fontSize: "14px",
                color: isFinished ? "textDisabled" : "textSubtle",
                children: subTitle
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PoolCardHeader);


/***/ }),

/***/ 12020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ StyledCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32692);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38144);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 280px;\n  max-width: 100%;\n  margin: 0 0 24px 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-self: baseline;\n  position: relative;\n  color: ",
        ";\n\n  ",
        " {\n    max-width: 350px;\n    margin: 0 12px 46px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-34431ece-0"
})(_templateObject(), function(param) {
    var isFinished = param.isFinished, theme = param.theme;
    return theme.colors[isFinished ? "textDisabled" : "secondary"];
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (StyledCard)));


/***/ }),

/***/ 37325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PoolCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardRibbon.tsx
var CardRibbon = __webpack_require__(18842);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(23774);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(30621);
// EXTERNAL MODULE: ./src/contexts/Localization/index.tsx + 3 modules
var Localization = __webpack_require__(99150);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(35128);
// EXTERNAL MODULE: ./src/components/TokenImage/index.tsx
var TokenImage = __webpack_require__(95239);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx + 1 modules
var useTooltip = __webpack_require__(36544);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/TooltipText.tsx
var TooltipText = __webpack_require__(17634);
// EXTERNAL MODULE: ./src/views/Pools/components/Apr.tsx
var Apr = __webpack_require__(67802);
;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/AprRow.tsx




var AprRow = function(param) {
    var pool = param.pool, stakedBalance = param.stakedBalance, _performanceFee = param.performanceFee, performanceFee = _performanceFee === void 0 ? 0 : _performanceFee, _showIcon = param.showIcon, showIcon = _showIcon === void 0 ? true : _showIcon;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var vaultKey = pool.vaultKey;
    var tooltipContent = vaultKey ? t("APY includes compounding, APR doesn’t. This pool’s CAKE is compounded automatically, so we show APY.") : t("This pool’s rewards aren’t compounded automatically, so we show APR");
    var ref = (0,useTooltip/* default */.Z)(tooltipContent, {
        placement: "bottom-start"
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipText/* default */.Z, {
                ref: targetRef,
                children: vaultKey ? "".concat(t("APY"), ":") : "".concat(t("APR"), ":")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Apr/* default */.Z, {
                pool: pool,
                stakedBalance: stakedBalance,
                performanceFee: performanceFee,
                showIcon: showIcon
            })
        ]
    });
};
/* harmony default export */ var PoolCard_AprRow = (AprRow);

// EXTERNAL MODULE: ./src/views/Pools/components/PoolCard/StyledCard.tsx
var StyledCard = __webpack_require__(12020);
// EXTERNAL MODULE: ./src/views/Pools/components/PoolCard/CardFooter/index.tsx
var CardFooter = __webpack_require__(73322);
// EXTERNAL MODULE: ./src/views/Pools/components/PoolCard/PoolCardHeader.tsx
var PoolCardHeader = __webpack_require__(68624);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./src/config/constants/types.ts
var types = __webpack_require__(97971);
// EXTERNAL MODULE: ./src/views/Pools/hooks/useProfileRequirement.ts
var useProfileRequirement = __webpack_require__(67532);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(20253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(19729);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 1 modules
var useContract = __webpack_require__(5039);
// EXTERNAL MODULE: ./src/views/Pools/hooks/useApprove.tsx + 1 modules
var useApprove = __webpack_require__(51029);
;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/CardActions/ApprovalAction.tsx





var ApprovalAction = function(param) {
    var pool = param.pool, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var sousId = pool.sousId, stakingToken = pool.stakingToken, earningToken = pool.earningToken;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var stakingTokenContract = (0,useContract/* useERC20 */.X_)(stakingToken.address || "");
    var ref = (0,useApprove/* useApprovePool */.iB)(stakingTokenContract, sousId, earningToken.symbol), handleApprove = ref.handleApprove, pendingTx = ref.pendingTx;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            width: "100%",
            height: "52px"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            isLoading: pendingTx,
            endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                spin: true,
                color: "currentColor"
            }) : null,
            disabled: pendingTx,
            onClick: function() {
                handleApprove();
            },
            width: "100%",
            children: t("Enable")
        })
    });
};
/* harmony default export */ var CardActions_ApprovalAction = (ApprovalAction);

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(9941);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(5527);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Minus.tsx
var Minus = __webpack_require__(72943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Add.tsx
var Add = __webpack_require__(543);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(65044);
// EXTERNAL MODULE: ./src/components/Balance.tsx
var Balance = __webpack_require__(20922);
// EXTERNAL MODULE: ./src/views/Pools/components/PoolCard/Modals/NotEnoughTokensModal.tsx
var NotEnoughTokensModal = __webpack_require__(67576);
// EXTERNAL MODULE: ./src/views/Pools/components/PoolCard/Modals/StakeModal.tsx + 2 modules
var StakeModal = __webpack_require__(29458);
;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/CardActions/StakeActions.tsx









var StakeAction = function(param) {
    var pool = param.pool, stakingTokenBalance = param.stakingTokenBalance, stakedBalance = param.stakedBalance, isBnbPool = param.isBnbPool, isStaked = param.isStaked, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var stakingToken = pool.stakingToken, stakingTokenPrice = pool.stakingTokenPrice, isFinished = pool.isFinished, userData = pool.userData;
    var stakingLimit = 0;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var stakedTokenBalance = (0,formatBalance/* getBalanceNumber */.mW)(stakedBalance, stakingToken.decimals);
    var stakedTokenDollarBalance = (0,formatBalance/* getBalanceNumber */.mW)(stakedBalance.multipliedBy(stakingTokenPrice), stakingToken.decimals);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(NotEnoughTokensModal/* default */.Z, {
        tokenSymbol: stakingToken.symbol
    })), 1), onPresentTokenRequired = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(StakeModal/* default */.Z, {
        isBnbPool: isBnbPool,
        pool: pool,
        stakingTokenBalance: stakingTokenBalance,
        stakingTokenPrice: stakingTokenPrice
    })), 1), onPresentStake = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(StakeModal/* default */.Z, {
        stakingTokenBalance: stakingTokenBalance,
        isBnbPool: isBnbPool,
        pool: pool,
        stakingTokenPrice: stakingTokenPrice,
        isRemovingStake: true
    })), 1), onPresentUnstake = ref2[0];
    var ref3 = (0,useTooltip/* default */.Z)(t("You’ve already staked the maximum amount you can stake in this pool!"), {
        placement: "bottom"
    }), targetRef = ref3.targetRef, tooltip = ref3.tooltip, tooltipVisible = ref3.tooltipVisible;
    var reachStakingLimit = new bignumber/* default */.Z(stakingLimit).gt(0) && userData.stakedBalance.gte(stakingLimit);
    var renderStakeAction = function() {
        return isStaked ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "space-between",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    flexDirection: "column",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.ZP, {
                                bold: true,
                                fontSize: "20px",
                                decimals: 3,
                                value: stakedTokenBalance
                            }),
                            (stakingTokenPrice === null || stakingTokenPrice === void 0 ? void 0 : stakingTokenPrice.toNumber()) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textSubtle",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.ZP, {
                                    fontSize: "12px",
                                    color: "textSubtle",
                                    decimals: 2,
                                    value: stakedTokenDollarBalance,
                                    prefix: "~",
                                    unit: " USD"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            variant: "secondary",
                            onClick: onPresentUnstake,
                            mr: "6px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {
                                color: "primary",
                                width: "24px"
                            })
                        }),
                        reachStakingLimit ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            ref: targetRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                variant: "secondary",
                                disabled: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                    color: "textDisabled",
                                    width: "24px",
                                    height: "24px"
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            variant: "secondary",
                            onClick: stakingTokenBalance.gt(0) ? onPresentStake : onPresentTokenRequired,
                            disabled: isFinished,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                color: "primary",
                                width: "24px",
                                height: "24px"
                            })
                        })
                    ]
                }),
                tooltipVisible && tooltip
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            disabled: isFinished,
            onClick: stakingTokenBalance.gt(0) ? onPresentStake : onPresentTokenRequired,
            children: t("Stake")
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            width: "100%",
            height: "52px"
        }) : renderStakeAction()
    });
};
/* harmony default export */ var StakeActions = (StakeAction);

// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./src/views/Pools/components/PoolCard/Modals/CollectModal.tsx + 1 modules
var CollectModal = __webpack_require__(68971);
;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/CardActions/HarvestActions.tsx







var HarvestActions = function(param) {
    var earnings = param.earnings, earningToken = param.earningToken, sousId = param.sousId, isBnbPool = param.isBnbPool, earningTokenPrice = param.earningTokenPrice, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var earningTokenBalance = (0,formatBalance/* getBalanceNumber */.mW)(earnings, earningToken.decimals);
    var formattedBalance = (0,formatBalance/* formatNumber */.uf)(earningTokenBalance, 3, 3);
    var earningTokenDollarBalance = (0,formatBalance/* getBalanceNumber */.mW)(earnings.multipliedBy(earningTokenPrice), earningToken.decimals);
    var fullBalance = (0,formatBalance/* getFullDisplayBalance */.NJ)(earnings, earningToken.decimals);
    var hasEarnings = earnings.toNumber() > 0;
    var isCompoundPool = sousId === 0;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(CollectModal/* default */.Z, {
        formattedBalance: formattedBalance,
        fullBalance: fullBalance,
        earningToken: earningToken,
        earningsDollarValue: earningTokenDollarBalance,
        sousId: sousId,
        isBnbPool: isBnbPool,
        isCompoundPool: isCompoundPool
    })), 1), onPresentCollect = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justifyContent: "space-between",
        alignItems: "center",
        mb: "16px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                flexDirection: "column",
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: "80px",
                    height: "48px"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: hasEarnings ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.ZP, {
                                bold: true,
                                fontSize: "20px",
                                decimals: 5,
                                value: earningTokenBalance
                            }),
                            earningTokenPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.ZP, {
                                display: "inline",
                                fontSize: "12px",
                                color: "textSubtle",
                                decimals: 2,
                                prefix: "~",
                                value: earningTokenDollarBalance,
                                unit: " USD"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                color: "textDisabled",
                                children: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "textDisabled",
                                children: "0 USD"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                disabled: !hasEarnings,
                onClick: onPresentCollect,
                children: isCompoundPool ? t("Collect") : t("Harvest")
            })
        ]
    });
};
/* harmony default export */ var CardActions_HarvestActions = (HarvestActions);

// EXTERNAL MODULE: ./src/views/Pools/components/ProfileRequirementWarning.tsx
var ProfileRequirementWarning = __webpack_require__(95506);
;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/CardActions/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var InlineText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-f6298472-0"
})(_templateObject());
var CardActions = function(param) {
    var pool = param.pool, stakedBalance = param.stakedBalance;
    var sousId = pool.sousId, stakingToken = pool.stakingToken, earningToken = pool.earningToken, harvest = pool.harvest, poolCategory = pool.poolCategory, userData = pool.userData, earningTokenPrice = pool.earningTokenPrice, profileRequirement = pool.profileRequirement;
    // Pools using native BNB behave differently than pools using a token
    var isBnbPool = poolCategory === types/* PoolCategory.BINANCE */.jh.BINANCE;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var allowance = (userData === null || userData === void 0 ? void 0 : userData.allowance) ? new bignumber/* default */.Z(userData.allowance) : bigNumber/* BIG_ZERO */.HW;
    var stakingTokenBalance = (userData === null || userData === void 0 ? void 0 : userData.stakingTokenBalance) ? new bignumber/* default */.Z(userData.stakingTokenBalance) : bigNumber/* BIG_ZERO */.HW;
    var earnings = (userData === null || userData === void 0 ? void 0 : userData.pendingReward) ? new bignumber/* default */.Z(userData.pendingReward) : bigNumber/* BIG_ZERO */.HW;
    var needsApproval = !allowance.gt(0) && !isBnbPool;
    var isStaked = stakedBalance.gt(0);
    var isLoading = !userData && !needsApproval;
    var ref = (0,useProfileRequirement/* useProfileRequirement */.f)(profileRequirement), notMeetRequired = ref.notMeetRequired, notMeetThreshold = ref.notMeetThreshold;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: "column",
            children: [
                harvest && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            display: "inline",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineText, {
                                    color: "secondary",
                                    textTransform: "uppercase",
                                    bold: true,
                                    fontSize: "12px",
                                    children: "".concat(earningToken.symbol, " ")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineText, {
                                    color: "textSubtle",
                                    textTransform: "uppercase",
                                    bold: true,
                                    fontSize: "12px",
                                    children: t("Earned")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions_HarvestActions, {
                            earnings: earnings,
                            earningToken: earningToken,
                            sousId: sousId,
                            earningTokenPrice: earningTokenPrice,
                            isBnbPool: isBnbPool,
                            isLoading: isLoading
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "inline",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InlineText, {
                            color: isStaked ? "secondary" : "textSubtle",
                            textTransform: "uppercase",
                            bold: true,
                            fontSize: "12px",
                            children: [
                                isStaked ? stakingToken.symbol : t("Stake"),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineText, {
                            color: isStaked ? "textSubtle" : "secondary",
                            textTransform: "uppercase",
                            bold: true,
                            fontSize: "12px",
                            children: isStaked ? t("Staked") : "".concat(stakingToken.symbol)
                        })
                    ]
                }),
                notMeetRequired || notMeetThreshold ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileRequirementWarning/* ProfileRequirementWarning */.Q, {
                    profileRequirement: profileRequirement
                }) : needsApproval ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CardActions_ApprovalAction, {
                    pool: pool,
                    isLoading: isLoading
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StakeActions, {
                    isLoading: isLoading,
                    pool: pool,
                    stakingTokenBalance: stakingTokenBalance,
                    stakedBalance: stakedBalance,
                    isBnbPool: isBnbPool,
                    isStaked: isStaked
                })
            ]
        })
    });
};
/* harmony default export */ var PoolCard_CardActions = (CardActions);

;// CONCATENATED MODULE: ./src/views/Pools/components/PoolCard/index.tsx












var PoolCard = function(param) {
    var pool = param.pool, account = param.account;
    var sousId = pool.sousId, stakingToken = pool.stakingToken, earningToken = pool.earningToken, isFinished = pool.isFinished, userData = pool.userData;
    var t = (0,Localization/* useTranslation */.$G)().t;
    var stakedBalance = (userData === null || userData === void 0 ? void 0 : userData.stakedBalance) ? new bignumber/* default */.Z(userData.stakedBalance) : bigNumber/* BIG_ZERO */.HW;
    var accountHasStakedBalance = stakedBalance.gt(0);
    var isCakePool = earningToken.symbol === "CAKE" && stakingToken.symbol === "CAKE";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard/* StyledCard */.r, {
        isFinished: isFinished && sousId !== 0,
        ribbon: isFinished && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardRibbon/* default */.Z, {
            variantColor: "textDisabled",
            text: t("Finished")
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PoolCardHeader/* default */.Z, {
                isStaking: accountHasStakedBalance,
                isFinished: isFinished && sousId !== 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolCardHeader/* PoolCardHeaderTitle */.e, {
                        title: isCakePool ? t("Manual") : t("Earn %asset%", {
                            asset: earningToken.symbol
                        }),
                        subTitle: isCakePool ? t("Earn CAKE, stake CAKE") : t("Stake %symbol%", {
                            symbol: stakingToken.symbol
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenImage/* TokenPairImage */.q, {
                        primaryToken: earningToken,
                        secondaryToken: stakingToken,
                        width: 40,
                        height: 40
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolCard_AprRow, {
                        pool: pool,
                        stakedBalance: stakedBalance
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        mt: "24px",
                        flexDirection: "column",
                        children: account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PoolCard_CardActions, {
                            pool: pool,
                            stakedBalance: stakedBalance
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    mb: "10px",
                                    textTransform: "uppercase",
                                    fontSize: "12px",
                                    color: "textSubtle",
                                    bold: true,
                                    children: t("Start earning")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardFooter/* default */.Z, {
                pool: pool,
                account: account
            })
        ]
    });
};
/* harmony default export */ var components_PoolCard = (PoolCard);


/***/ })

}]);